export { TagRipple } from './tag-ripple.component';
export { TagComponent } from './tag.component';
